<template>
  <el-dialog title="批量设置" :visible.sync="dialogVisible" width="500px" :close="handleClose">
    <div style="padding: 20px">
      <label style="float: left; width: 100px; text-align: right;">{{ attributes.name }}</label>
      <span style="margin-left: 10px">
        <el-select
          v-if="['1', '2', '3', '4'].includes(attributes.inputType)"
          :multiple="['2', '4'].includes(attributes.inputType)"
          :filterable="['1'].includes(attributes.inputType)"
          :allow-create="['1'].includes(attributes.inputType)"
          :default-first-option="['1'].includes(attributes.inputType)"
          v-model="value"
        >
          <el-option v-for="op in attributes.attrValues" :key="op.attrValueID" :value="op.name" :label="op.name"></el-option>
        </el-select>
        <el-date-picker v-else-if="['5'].includes(attributes.inputType)" v-model="value" type="date" placeholder="选择日期">
        </el-date-picker>
        <el-input-number v-else-if="['-1'].includes(attributes.inputType)" v-model="value" :controls="false"></el-input-number>
        <el-input style="width: 156px" v-else-if="attributes.inputType" v-model="value"></el-input>
      </span>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="sure">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      dialogVisible: false,
      value: '',
      attributes: {},
      opts: {

      },
    };
  },

  methods: {
    openDialog(opts = {}) {
      this.dialogVisible = true;
      this.$set(this, 'opts', opts)
      this.attributes = opts.col;
      if (['2', '4'].includes(this.attributes.inputType)) {
        this.value = [];
      } else {
        this.value = ''
      }
    },
    sure() {
      this.$emit('sureFn', this.value, this.attributes)
      this.handleClose();
    },

    handleClose() {
      this.dialogVisible = false;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
</style>
